import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/home/index.vue';
// import Activity from './views/activity/index.vue';
// import ActivityDetail from './views/activity/detail.vue';
import ActivityForm from './views/activity/form.vue';
import Info from './views/home/info.vue';
import Law from './views/home/law.vue';
import Award from './views/home/award.vue';
import Product from './views/product/index.vue';

Vue.use(Router);

export default new Router({
    routes: [
        // 首頁
        {
            path: '/',
            name: 'Home',
            component: Home,
        },
        // 開運笑起來
        {
            path: '/Activity/Index',
            name: 'Activity',
            component: Home, // Activity,
        },
        // 開運笑起來: 詳細頁
        {
            path: '/Activity/Detail/:id',
            props: true,
            name: 'ActivityDetail',
            component: Home, // ActivityDetail,
        },
        // 開運笑起來: 表單
        {
            path: '/Activity/Form/:id',
            props: true,
            name: 'ActivityForm',
            component: ActivityForm,
        },
        // 活動辦法
        {
            path: '/Home/Info',
            name: 'Info',
            component: Info,
        },
        // 個資條款
        {
            path: '/Home/Law',
            name: 'Law',
            component: Law,
        },
        // 中獎名單
        {
            path: '/Home/Award',
            name: 'Award',
            component: Award,
        },
        // 產品介紹
        {
            path: '/Product/Index',
            name: 'Product',
            component: Product,
        },
    ],
});
